module.exports = __webpack_public_path__ + "media/components/country-flag/static/bv-cb6de9f13d697eed425360cb123288e0.svg";